import { ITypographComponent } from '../../interfaces/IComponents';
import clsx from 'clsx';
import styles from './EpTypograph.module.scss';

/**
 * Typograph Text component
 */

const variants = {
  p: 'p',
  i: 'i',
  span: 'span',
  strong: 'strong',
};

export const EpTypographText = ({
  align,
  children,
  color,
  customClass,
  fweight,
  size,
  variant,
}: ITypographComponent) => {
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  const Component: any = variant
    ? variants[variant as keyof typeof variants]
    : 'p';
  const fillColor = `typograph--color-${color}`;
  const fontSize = `typograph--size-${size}`;
  const fontWeight = `typograph--weight-${fweight}`;
  const textAlign = `typograph--align-${align}`;

  return (
    <Component
      className={clsx(
        styles[fillColor],
        styles[fontSize],
        styles[fontWeight],
        styles[textAlign],
        customClass,
      )}
    >
      {children}
    </Component>
  );
};
